import { useState } from "react";
import { CircleNotch } from "@phosphor-icons/react";
import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from "../components/ui/alert-dialog";
import { Button } from "../components/ui/button";

// DialogConfirmacao: substitui window.confirm() por um popup do shadcn.
// Uso: controle aberto/fechado externamente; chama onConfirmar() ao clicar
// no botão de ação. Aguarda a operação terminar antes de fechar o dialog.
// Estilo destrutivo por padrão (botão vermelho).
export default function DialogConfirmacao({
    aberto,
    setAberto,
    titulo,
    descricao,
    rotuloAcao = "Confirmar",
    rotuloCancelar = "Cancelar",
    destrutivo = true,
    onConfirmar,
    testId = "dialog-confirmacao",
}) {
    const [executando, setExecutando] = useState(false);

    const acaoClasse = destrutivo
        ? "bg-red-600 text-white hover:bg-red-500 focus:ring-red-600"
        : "bg-white text-zinc-950 hover:bg-zinc-200";

    const handleConfirmar = async () => {
        if (executando) return;
        setExecutando(true);
        try {
            await onConfirmar?.();
        } finally {
            setExecutando(false);
            setAberto(false);
        }
    };

    return (
        <AlertDialog open={aberto} onOpenChange={(v) => {
            // Impede fechar o dialog enquanto a operação está em andamento
            if (executando) return;
            setAberto(v);
        }}>
            <AlertDialogContent
                className="bg-zinc-950 border border-zinc-800 text-zinc-100"
                data-testid={testId}
            >
                <AlertDialogHeader>
                    <AlertDialogTitle className="font-medium tracking-tight">{titulo}</AlertDialogTitle>
                    {descricao && (
                        <AlertDialogDescription className="text-zinc-400 text-sm">
                            {descricao}
                        </AlertDialogDescription>
                    )}
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel
                        data-testid={`${testId}-cancelar`}
                        disabled={executando}
                        className="bg-transparent border-zinc-800 text-zinc-300 hover:bg-zinc-900 hover:text-zinc-100"
                    >
                        {rotuloCancelar}
                    </AlertDialogCancel>
                    <Button
                        data-testid={`${testId}-confirmar`}
                        className={acaoClasse}
                        disabled={executando}
                        onClick={handleConfirmar}
                    >
                        {executando && <CircleNotch size={16} className="animate-spin mr-2" />}
                        {rotuloAcao}
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
